import { $, $$, on } from './util.js';

/* 8. ARTICLE FEEDBACK (FRD 6.8) — local only, no endpoint yet */
export function initFeedback() {
	var strip = $('#articleFeedback');
	if (!strip) { return; }
	var form = $('#fbForm', strip);
	var thanks = $('#fbThanks', strip);

	$$('[data-feedback]', strip).forEach(function (btn) {
		on(btn, 'click', function () {
			var helpful = btn.getAttribute('data-feedback') === 'yes';
			$('.fb-btns', strip).hidden = true;
			if (helpful) {
				thanks.textContent = 'Thanks — glad this helped.';
				thanks.hidden = false;
			} else if (form) {
				form.classList.add('open');
			}
		});
	});

	on(form, 'submit', function (e) {
		e.preventDefault();
		form.classList.remove('open');
		thanks.textContent = 'Thanks — your note has been recorded for the docs team.';
		thanks.hidden = false;
	});
}
